require('dotenv').config();

import * as mainConfig from './config';

// Named exports for backward compatibility - SERVER SIDE ONLY
export const databaseUrl = process.env.DATABASE_URL;
export const cronTimezone = process.env.CRON_TIMEZONE;

export const auth = {
  jwt: { secret: process.env.JWT_SECRET },
  ...mainConfig.auth
};
